module.exports = __webpack_public_path__ + "img/muenchen_sylvester_2016_ref.65008127.jpg";